// @vue/component
export default {
  name: 'portfolio',
  props: {
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
